/* Handora collection filter, v5 (19/10/2026): thedeerly.com layout. Styles: assets/ho-facets.css on top of
   assets/ho-native-discovery.css. Works on the theme's own filter form, so the theme still does the filtering
   (one request per change, address bar kept in step). This script only adds what the markup lacks:
   - toolbar "Sort by: Best selling" text and, on touch screens, the phone's own picker;
   - phone drawer: title "Filter and sort" with the product count under it, a "Sort by:" picker row,
     footer "Remove all" + "Apply", a dimmed page behind it (tap it to close), html.ho-filter-open;
   - desktop bar: each group opens as a dropdown (one at a time, closes on outside click or Esc, stays open
     while the theme redraws after a tick), and a "Clear all" link when something is ticked.
   Runs again whenever the theme redraws the filters. Loaded from snippets/ho-tier-cart-sync.liquid on
   collection and search pages. */
(function () {
  if (window.__hoFilterUi) return;
  window.__hoFilterUi = true;

  var desk = window.matchMedia('(min-width: 768px)');
  var touch = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  var picked = null;
  var openKey = '';

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function firstText(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }
  function countEl() { return document.querySelector('.collection__sticky-bar .collection__products-count, .collection__products-count'); }
  function countNum() { return parseInt(txt(countEl()).replace(/[^\d]/g, ''), 10); }
  function countLabel() {
    var n = countNum();
    if (isNaN(n)) return '';
    return n + (n === 1 ? ' product' : ' products');
  }
  function anyActive() {
    return !!document.querySelector('.collection__filters .filter__input:checked, .collection__filters .collection__filters__reset.is-visible');
  }
  function currentSort(box) {
    var want = picked && Date.now() - picked.at < 4000 ? picked.value : new URLSearchParams(location.search).get('sort_by');
    var input = null;
    if (want) box.querySelectorAll('.collection__sort__input').forEach(function (i) { if (i.value === want) input = i; });
    if (!input) input = box.querySelector('.collection__sort__input:checked');
    return input;
  }
  function labelFor(box, input) { return input ? txt(box.querySelector('label[for="' + input.id + '"]')) : ''; }
  function chooseSort(box, value) {
    var pick = null;
    box.querySelectorAll('.collection__sort__input').forEach(function (i) { if (i.value === value) pick = i; });
    var lab = pick ? box.querySelector('label[for="' + pick.id + '"]') : null;
    picked = { value: value, at: Date.now() };
    if (lab) lab.click(); else if (pick) pick.click();
  }

  /* Toolbar sort button (desktop): "Sort by: Best selling". */
  function sortLabels() {
    document.querySelectorAll('.collection__sort-bar').forEach(function (box) {
      var btn = box.querySelector('.collection__sort__label');
      if (!btn) return;
      var input = currentSort(box);
      var value = labelFor(box, input);
      var v = btn.querySelector('.ho-sort__v');
      if (!v) {
        var t = firstText(btn);
        var wrap = document.createElement('span');
        wrap.className = 'ho-sort__t';
        var k = document.createElement('span');
        k.className = 'ho-sort__k';
        k.textContent = t ? t.textContent.trim() : 'Sort by';
        v = document.createElement('span');
        v.className = 'ho-sort__v';
        wrap.appendChild(k);
        wrap.appendChild(v);
        if (t) btn.replaceChild(wrap, t); else btn.insertBefore(wrap, btn.firstChild);
      }
      if (v.textContent !== value) v.textContent = value;
      if (btn.classList.contains('ho-sort--has') !== !!value) btn.classList.toggle('ho-sort--has', !!value);
      if (touch) nativeSort(box, input, 'ho-nsort');
    });
  }

  /* An invisible <select> over a row, so phones and tablets get their own picker. */
  function nativeSort(box, current, cls, host) {
    var inputs = [].slice.call(box.querySelectorAll('.collection__sort__input'));
    if (!inputs.length) return null;
    host = host || box;
    var sel = host.querySelector('select.' + cls);
    if (!sel) {
      sel = document.createElement('select');
      sel.className = cls;
      sel.setAttribute('aria-label', 'Sort by');
      sel.addEventListener('change', function (e) { e.stopPropagation(); chooseSort(box, sel.value); });
      host.appendChild(sel);
      if (cls === 'ho-nsort') box.classList.add('ho-nsort-on');
    }
    var sig = inputs.map(function (i) { return i.value; }).join('|');
    if (sel.__sig !== sig) {
      sel.__sig = sig;
      sel.innerHTML = '';
      inputs.forEach(function (i) {
        var o = document.createElement('option');
        o.value = i.value;
        o.textContent = labelFor(box, i) || i.value;
        sel.appendChild(o);
      });
    }
    if (current && sel.value !== current.value) sel.value = current.value;
    return sel;
  }

  /* Drawer "Sort by:" row with the current choice and the phone's picker. */
  function drawerSort() {
    document.querySelectorAll('.collection__filters .collection__sort').forEach(function (box) {
      var row = box.querySelector('.ho-dsort');
      if (!row) {
        row = document.createElement('div');
        row.className = 'ho-dsort';
        row.innerHTML = '<span class="ho-dsort__k">Sort by:</span><span class="ho-dsort__pick"><span class="ho-dsort__v"></span></span>';
        box.insertBefore(row, box.firstChild);
        box.classList.add('ho-dsort-on');
      }
      var input = currentSort(box);
      var v = row.querySelector('.ho-dsort__v');
      var value = labelFor(box, input);
      if (v.textContent !== value) v.textContent = value;
      nativeSort(box, input, 'ho-dsort__sel', row.querySelector('.ho-dsort__pick'));
    });
  }

  /* Drawer title: "Filter and sort", the product count underneath. */
  function titles() {
    var count = countLabel();
    document.querySelectorAll('.collection__filters .collection__filters__title').forEach(function (title) {
      var s = title.querySelector(':scope > span');
      if (!s) { s = document.createElement('span'); title.textContent = ''; title.appendChild(s); }
      if (!s.querySelector('.ho-ft')) s.innerHTML = '<span class="ho-ft"></span><span class="ho-ft-by"></span><span class="ho-fcnt"></span>';
      var ft = s.querySelector('.ho-ft');
      if (ft.textContent !== 'Filter and sort') ft.textContent = 'Filter and sort';
      var c = s.querySelector('.ho-fcnt');
      if (c.textContent !== count) c.textContent = count;
    });
  }

  /* Drawer footer: "Remove all" + "Apply". */
  function footer() {
    var active = anyActive();
    document.querySelectorAll('.collection__filters .collection__filters-bottom').forEach(function (f) {
      var show = f.querySelector('.collection__filters__close-bottom');
      if (!show) return;
      if (!f.querySelector('.ho-fclear')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ho-fclear';
        f.insertBefore(b, f.firstChild);
      }
      var cb = f.querySelector('.ho-fclear');
      if (cb.textContent !== 'Remove all') cb.textContent = 'Remove all';
      if (cb.disabled === active) cb.disabled = !active;
      var t = firstText(show);
      if (t && t.textContent.trim() !== 'Apply') t.textContent = 'Apply';
    });
  }

  /* Toolbar badge with the number of ticked options (phone). */
  function toolbarBadge() {
    var n = document.querySelectorAll('.collection__filters .filter__input:checked').length;
    document.querySelectorAll('#CollectionStickyBar .collection__filters__toggle').forEach(function (btn) {
      var b = btn.querySelector('.ho-tbadge');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('span'); b.className = 'ho-tbadge'; btn.appendChild(b); }
      if (b.textContent !== String(n)) b.textContent = String(n);
    });
  }

  /* Desktop bar: "Clear all" at the end when something is ticked. */
  function deskClear() {
    var form = document.querySelector('.collection__filters [data-collection-filters-form]');
    if (!form) return;
    var b = form.querySelector('.ho-dclear');
    var active = anyActive();
    if (!active) { if (b) b.remove(); return; }
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'ho-dclear';
      b.textContent = 'Clear all';
      form.appendChild(b);
    }
  }

  /* Desktop dropdowns: keep the open one open across the theme's redraws. */
  function groupKey(group) { return txt(group.querySelector('.collection__filter__title > span')).replace(/\d+$/, '').trim(); }
  function syncOpen() {
    document.querySelectorAll('.collection__filters .collection__filter').forEach(function (g) {
      var on = desk.matches && openKey && groupKey(g) === openKey;
      if (g.classList.contains('ho-open') !== !!on) g.classList.toggle('ho-open', !!on);
      var t = g.querySelector('.collection__filter__title');
      if (t && desk.matches) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  /* Phone drawer state on <html>, for the dimmed page and the rewards button. */
  function drawerState() {
    var open = !desk.matches && !!document.querySelector('.collection__filters.collection__filters--visible');
    if (document.documentElement.classList.contains('ho-filter-open') !== open) document.documentElement.classList.toggle('ho-filter-open', open);
  }

  function closeDrawer() {
    var x = document.querySelector('.collection__filters [data-close-filters]');
    if (x) x.click();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Remove all (drawer) and Clear all (desktop bar): the theme's own reset link keeps everything in step. */
    if (t.closest('.ho-fclear') || t.closest('.ho-dclear')) {
      e.preventDefault();
      var reset = document.querySelector('.collection__filters .collection__filters__reset');
      if (reset) reset.click();
      return;
    }

    if (desk.matches) {
      var title = t.closest('.collection__filters .collection__filter__title');
      if (title) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var g = title.closest('.collection__filter');
        var k = groupKey(g);
        openKey = openKey === k ? '' : k;
        syncOpen();
        return;
      }
      if (openKey && !t.closest('.collection__filters .collection__filter')) { openKey = ''; syncOpen(); }
      return;
    }

    /* Phone: a tap on the dimmed page closes the drawer. */
    if (document.documentElement.classList.contains('ho-filter-open') && !t.closest('.collection__filters') && !t.closest('[data-toggle-filters]')) {
      e.preventDefault();
      closeDrawer();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openKey) { openKey = ''; syncOpen(); }
  });

  var queued = 0;
  function run() {
    queued = 0;
    try { sortLabels(); drawerSort(); titles(); footer(); toolbarBadge(); deskClear(); syncOpen(); drawerState(); } catch (e) {}
  }
  function soon() { if (!queued) queued = requestAnimationFrame(run); }

  /* Desktop: ticking inside a dropdown must not throw the page down to the grid (the theme scrolls there
     after every filter change). Hold the scroll position for a moment after a tick. */
  var hold = null;
  /* The theme's smooth scroll to the grid is skipped while the hold is on (fighting it left the page half way). */
  var nativeScrollTo = window.scrollTo;
  window.scrollTo = function (a) {
    if (hold && Date.now() < hold.until && a && typeof a === 'object' && a.behavior === 'smooth') return;
    return nativeScrollTo.apply(window, arguments);
  };
  window.addEventListener('scroll', function () {
    if (hold && Date.now() < hold.until && Math.abs(window.scrollY - hold.y) > 2) window.scrollTo(0, hold.y);
  }, { passive: true });
  document.addEventListener('change', function (e) {
    if (desk.matches && e.target && e.target.closest && e.target.closest('.collection__filters .collection__filter')) {
      hold = { y: window.scrollY, until: Date.now() + 2500 };
    }
    if (e.target && e.target.matches && e.target.matches('.collection__sort__input')) {
      picked = { value: e.target.value, at: Date.now() };
      soon(); setTimeout(soon, 800); setTimeout(soon, 4100);
    }
  }, true);
  window.addEventListener('popstate', function () { setTimeout(soon, 300); });
  if (desk.addEventListener) desk.addEventListener('change', function () { openKey = ''; soon(); });
  function start() {
    run();
    if ('MutationObserver' in window) new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
